module.exports = __webpack_public_path__ + "h5/img/rengou.310f5d7c.png";